<template>
	<div class="content">
		<header>
			<h1>La tua casa a Sciacca</h1>
		</header>

		<main>
			<div class="slider" v-dragscroll="true">
				<div class="box"><img src="../assets/img/spazio.jpg" alt="" /></div>

				<div class="box">
					<img src="../assets/img/20210614_111105.jpg" alt="" />
				</div>
				<div class="box">
					<img src="../assets/img/caratteristiche.jpeg" alt="" />
				</div>
				<div class="box"><img src="../assets/img/colazione.jpg" alt="" /></div>
				<!-- <div class="box"><img src="../assets/img/slide2.jpg" alt="" /></div> -->
			</div>

			<div class="section colazione" id="colazione" :class="{ mobile: viewport }">
				<div class="left-cont">
					<h2>LA COLAZIONE SICILIANA</h2>
					<p>
						Vi offriamo noi la COLAZIONE ALLA SICILIANA migliore che ci sia e che potrete godervi ai tavoli di due delle
						migliori pasticcerie-bar di Sciacca, in locations comode da raggiungere e poste nei luoghi più belli della
						città. Assaporate la Brioscia con la granita siciliana di limone, gelsi neri, pistacchio, arancia,
						mandorla...oppure gustate un cappuccino con il meraviglioso dolce tipico siciliano che preferite: il
						cannolo, la cassata, l’iris, il raviolo di ricotta dolce...
					</p>
				</div>
				<div class="right-cont">
					<img src="../assets/img/colazione.jpg" alt="" />
				</div>
			</div>

			<div class="section spazio" id="spazio" :class="{ mobile: viewport, order: viewport }">
				<div class="right-cont">
					<img src="../assets/img/spazio.jpg" alt="" />
				</div>

				<div class="left-cont">
					<h2>Lo Spazio</h2>
					<p>
						Deliziosa casetta autonoma in posizione appartata ma in centro storico con terrazza panoramica con vista
						sulla città, sul porto e su Capo San Marco. Allestimento da 1 a 4 posti letto in base alle vostre esigenze.
						Camera con 2 letti singoli (oppure con un matrimoniale), soggiorno-cucina con 2 confortevoli divani letto da
						una piazza e mezza con vero materasso a molle alto 17 cm. (vedi foto), piccolo bagno con doccia. Tutti i
						vani sono con finestra. La casa misura circa 35 metri quadrati. Accesso per gli ospiti La casa ha un accesso
						privato, una terrazza e sarà interamente a vostra disposizione
					</p>
				</div>
			</div>

			<div class="section caratteristiche" id="caratteristiche" :class="{ mobile: viewport }">
				<div class="left-cont">
					<h2>Caratteristiche</h2>
					<p>Vista sul panorama urbano Vista sul porto Cucina Parcheggio gratuito in strada Aria condizionata</p>
				</div>
				<div class="right-cont">
					<img src="../assets/img/caratteristiche.jpeg" alt="" />
				</div>
			</div>
		</main>
	</div>
</template>

<script>
import { dragscroll } from 'vue-dragscroll';
export default {
	name: 'ContentComp',
	data() {
		return {
			viewport: false,
		};
	},
	directives: {
		dragscroll,
	},
	methods: {
		viewFunction() {
			if (window.innerWidth <= 1090) {
				this.viewport = true;
			} else {
				this.viewport = false;
			}
		},
	},
	mounted() {
		window.addEventListener('resize', this.viewFunction);
	},
	unmounted() {
		window.removeEventListener('resize', this.viewFunction);
	},
};
</script>

<style scoped lang="scss">
h2 {
	font-weight: bold;
}
.content {
	padding: 3vw 0 4vw;
	position: relative;
	background-color: rgb(255, 255, 255);
	width: 100%;

	header {
		width: 100%;
		height: 5em;
		display: flex;
		justify-content: center;
		h1 {
			font-size: 2em;
			color: black;
		}

		p {
			margin-left: auto;
		}
	}

	main {
		width: 100%;
		.slider {
			width: 100%;
			height: 550px;
			overflow-y: hidden;
			overflow-x: scroll;
			padding: 2vw;
			display: flex;
			flex-wrap: nowrap;
			cursor: grab;

			gap: 20px;

			&::-webkit-scrollbar {
				width: 0px;
				background: transparent; /* make scrollbar transparent */
			}

			.box {
				flex-grow: 0;
				flex-shrink: 0;
				flex-basis: auto;
				border-radius: 2rem;
				width: 400px;
				height: 100%;
				overflow: hidden;

				img {
					width: 100%;
					height: 100%;
					// background-size: cover;
					object-fit: cover;
				}
			}

			.box:first-child {
				width: 800px;
			}
		}

		.section {
			width: 100%;
			display: flex;
			gap: 5rem;
			// background-color: aqua;
			padding: 2em 8vw;

			.right-cont,
			.left-cont {
				font-size: 1.5em;
				// background-color: rgb(173, 173, 173);
				width: 50%;
				// min-height: 400px;
				border-radius: 20px;
			}

			.left-cont {
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
				gap: 1.5em;
			}

			img {
				width: 100%;
				height: 100%;
				object-fit: cover;
				border-radius: 20px;
			}
		}

		.section.mobile {
			display: flex;
			flex-direction: column;
			.right-cont,
			.left-cont {
				background-color: white;
				width: 100%;
				height: 100%;
			}
		}

		.section.order {
			flex-direction: column-reverse;
		}
	}
}

@media screen and (max-width: 600px) {
	.content {
		main {
			.slider {
				height: 300px;
			}
		}
	}
}
</style>
